<template>
  <!--<li><router-link to="/" class="header-link">Home</router-link></li>-->
  <header id="MainHeaderBarWrap">
    <div class="ContentAligher">
        <div id="LogoWrap">
          <router-link to="/" ><img src="@/assets/images/usc-logo.png" alt="USC Elevator Interiors"></router-link>
        </div>

        <nav id="MenuWrap" class="hidden-xs hidden-sm hidden-md">
          <ul>
              <li><router-link to="/about-us" >About Us </router-link></li>
              <li><router-link to="/services" >Services </router-link></li>
              <li><router-link to="/finishes" >Finishes </router-link></li>
              <li><router-link to="/portfolio" >Portfolio </router-link></li>
          </ul>
        </nav>

        <div id="MenuIcon">
          <span class="hamburger__text hidden-xs ">Menu</span><span class="hamburger__icon"></span>
        </div>
    </div>

  </header>
</template>
<script>
import * as $ from 'jquery'

export default{
  name: 'Header',
  mounted() {

        var $MenuOpen = false;
        $('#MenuIcon').click(function(event) {
          if($MenuOpen == false)
          {
            $("#myNav").height("100%");
            $(this).addClass('active');
            $MenuOpen = true;
            //setTimeout(function(){ AOS.init(); }, 300);
          }
        });

        $('#MenuIconClose, .overlay-content a').click(function(event) {
            $("#myNav").height("0%");
            $(this).removeClass('active');
            $MenuOpen = false;
            $('.overlay-content a').attr( "class", '' );
            $('.overlay-content span p').attr( "class", '' );
            $(document).trigger("scroll");
        });

  },
  updated(){

  }
}
</script>




// WEBPACK FOOTER //
// src/components/Header.vue